function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#355D96;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 11,
  className: "st0",
  width: 9.5,
  height: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 3,
  className: "st0",
  width: 6.5,
  height: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 7,
  className: "st0",
  width: 9.5,
  height: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 10,
  className: "st0",
  width: 6.5,
  height: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 7,
  className: "st0",
  width: 1.5,
  height: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 15,
  className: "st0",
  width: 9.5,
  height: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 18,
  className: "st0",
  width: 6.5,
  height: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 15,
  className: "st0",
  width: 1.5,
  height: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 7,
  className: "st0",
  width: 1.5,
  height: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 15,
  className: "st0",
  width: 1.5,
  height: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  y: 15,
  className: "st0",
  width: 1.5,
  height: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  className: "st0",
  width: 1.5,
  height: 4.5
}));

var SvgCitations = function SvgCitations(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.5 19.5",
    style: {
      enableBackground: "new 0 0 20.5 19.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCitations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/citations.191e41dd.svg";
export { ForwardRef as ReactComponent };